import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-registered-members',
  templateUrl: './registered-members.component.html',
  styleUrls: ['./registered-members.component.css']
})
export class RegisteredMembersComponent implements OnInit {

  @Input() NoOfRegisteredMembers: string;
  @Output() filterMembersEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterMembersEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/registered-members/registered-members.component.ts